import type { RelaunchUnreadSmsResponse, SmsTrackingPeriod } from '@gozoki/api-types'
import { gozokiApiWithAuth } from '../gozokiApi'

export interface ExportSmsTrackingCsvParams {
  period: SmsTrackingPeriod
}

export interface ExportSmsTrackingCsvResult {
  blob: Blob
  filename: string
}

const DEFAULT_FILENAME = 'suivi-sms.csv'

const extractFilename = (contentDisposition: string | undefined): string => {
  if (!contentDisposition) return DEFAULT_FILENAME
  const match = /filename="?([^";]+)"?/i.exec(contentDisposition)
  return match?.[1] ?? DEFAULT_FILENAME
}

export const exportSmsTrackingCsv = async (
  params: ExportSmsTrackingCsvParams,
): Promise<ExportSmsTrackingCsvResult> => {
  const response = await gozokiApiWithAuth.get<Blob>('/hr/planning/sms-tracking/export', {
    params,
    responseType: 'blob',
  })
  return {
    blob: response.data,
    filename: extractFilename(response.headers['content-disposition']),
  }
}

export interface RelaunchUnreadSmsParams {
  period: SmsTrackingPeriod
}

export const relaunchUnreadSms = async (
  params: RelaunchUnreadSmsParams,
): Promise<RelaunchUnreadSmsResponse> => {
  const response = await gozokiApiWithAuth.post<RelaunchUnreadSmsResponse>(
    '/hr/planning/sms-tracking/relaunch',
    params,
  )
  return response.data
}
